<!-- 列表单元格 -->
<template>
  <div
    :class="[
      'teas-cell',
      'mobile',
      'teas-cell-' + cellShape,
      border ? 'dsf-teas-border-bottom' : '',
    ]"
  >
    <slot name="front"></slot>
    <div class="teas-cell-hd" v-if="headerUrl || headerIcon || headerSvg">
      <!-- <img
        alt=""
        v-if="headerUrl"
        :class="['teas-cell-hd-header-img', 'teas-cell-hd-header-img-' + headerShape]"
        :src="headerUrl | imgFormat"
        :οnerrοr="errorimg"
      /> -->
      <van-image 
        v-if="headerUrl"
        :class="['teas-cell-hd-header-img', 'teas-cell-hd-header-img-' + headerShape]"
        :src="headerUrl | imgFormat"
        :error-icon="errorimg"
      >
      </van-image>
      <i
        v-if="headerIcon"
        class="teas-cell-hd-header-icon"
        :class="['iconfont', headerIcon]"
      ></i>
      <svg v-if="headerSvg" class="teas-cell-hd-svg-icon" aria-hidden="true">
        <use :xlink:href="headerSvg"></use>
      </svg>
    </div>
    <div class="teas-cell-bd">
      <!-- <div :class="['teas-cell-bd-title', titleClass]">
        {{ title }}
      </div> -->
      <div :class="['teas-cell-bd-title']">
        <slot name="titleLeft"> </slot>
        <div :class="['title', titleClass]">{{ title }}</div>
        <slot name="titleRight"> </slot>
      </div>
      <slot />
    </div>
    <div class="teas-cell-ft" v-if="hasFtSlot">
      <slot name="ft"> </slot>
    </div>
  </div>
</template>

<script>
// 数据格式案例
const testData = {
  // 显示的文字列表
  title:
    "这里是显示标题这里是显示标题这里是显示标题这里是显示标题这里是显示标题这里是显示标题这里是显示标题",
  // 头像图片
  headerUrl:
    "https://img2.baidu.com/it/u=2199116012,2247485209&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=350",
};

export default dsf.component({
  name: "DsfMobileTeasCell",
  ctrlCaption: "列表单元格",
  mixins: [$mixins.control],
  design: {},
  props: {
    // 头部-图片
    headerUrl: {
      type: String,
      default: "",
    },
    // 头部-icon
    headerIcon: {
      type: String,
      default: "",
    },
    // 头部-svg
    headerSvg: {
      type: String,
      default: "",
    },
    // 标题
    title: {
      type: String,
      default: "",
    },
    // 标题几行显示
    titleEllipsis: {
      type: Number,
      default: 1,
    },
    // 单元格圆角
    // square-半圆角  none-无圆角
    cellShape: {
      type: String,
      default: "circle",
    },
    // 头像圆角
    // circle-圆角   square-半圆角  none-无圆角
    headerShape: {
      type: String,
      default: "circle",
    },
    // 是否显示边框
    border: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errorimg: dsf.config.setting_public_user_default_header,
    };
  },
  computed: {
    titleClass() {
      switch (this.titleEllipsis) {
        case 1:
          return "van-ellipsis";
        case 2:
          return "van-multi-ellipsis--l2";
        default:
          return "van-ellipsis";
      }
    },
    hasFtSlot() {
      return this.$slots.ft;
    },
  },
  created() {},
  mounted() {
    // console.log(this.hasFtSlot)
    // console.log(this.$slots)
    // console.log(this.$slots.default)
  },
  methods: {},
});
</script>
